import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import theme from './theme';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </ErrorBoundary>
);

// Register service worker for PWA functionality (disabled in development)
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  // Unregister any existing service worker in development
  serviceWorkerRegistration.unregister();
}
